import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\GetDossierEnaosSalesExportController::__invoke
* @see app/Http/Controllers/Dossier/Partners/GetDossierEnaosSalesExportController.php
* @route '/api/dossier/{dossier}/enaos/sales-export'
*/
const GetDossierEnaosSalesExportController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierEnaosSalesExportController.url(args, options),
    method: 'get',
})

GetDossierEnaosSalesExportController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/enaos/sales-export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\GetDossierEnaosSalesExportController::__invoke
* @see app/Http/Controllers/Dossier/Partners/GetDossierEnaosSalesExportController.php
* @route '/api/dossier/{dossier}/enaos/sales-export'
*/
GetDossierEnaosSalesExportController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierEnaosSalesExportController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\GetDossierEnaosSalesExportController::__invoke
* @see app/Http/Controllers/Dossier/Partners/GetDossierEnaosSalesExportController.php
* @route '/api/dossier/{dossier}/enaos/sales-export'
*/
GetDossierEnaosSalesExportController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierEnaosSalesExportController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\GetDossierEnaosSalesExportController::__invoke
* @see app/Http/Controllers/Dossier/Partners/GetDossierEnaosSalesExportController.php
* @route '/api/dossier/{dossier}/enaos/sales-export'
*/
GetDossierEnaosSalesExportController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierEnaosSalesExportController.url(args, options),
    method: 'head',
})

export default GetDossierEnaosSalesExportController